export default "__VITE_ASSET__C6_KZc7d__"